import { Box, useTheme } from '@mui/joy';
import { useMediaQuery } from '../../hooks';
import { motion } from 'framer-motion';
import vote from '../../assets/collage_vote_hands_big_update.png';
import donate from '../../assets/collage_donate_big.png';
import circle from '../../assets/collage_circle.png';

const AnalysisHighlights = () => {
	const theme = useTheme();

	const matchesMd = useMediaQuery(theme.breakpoints.up('md'));
	const matchesSm = useMediaQuery(theme.breakpoints.up('sm'));

	return (
		<Box
			sx={{
				height: '100%'
			}}
		>
			<Box
				sx={{
					marginY: '35px',
					marginX: 'auto',
					position: 'relative',
					width: { xs: '250px', sm: '350px', md: '452.11px' },
					display: 'block',
					height: { xs: '200px', sm: '300px', md: '365px' }
				}}
			>
				<Box
					sx={{
						marginX: 'auto',
						borderRadius: 6,
						position: 'absolute',
						zIndex: 1,
						bottom: 0,
						height: 12,
						width: { xs: '200px', sm: '300px', md: '389px' },
						background: theme.palette.chaptersAnalysis.solidBg
					}}
				/>
				<motion.div
					animate={{ y: 0, opacity: 1, scaleX: 1 }}
					initial={{ y: 600, opacity: 0, scaleX: 1 }}
					transition={{ delay: 1, type: 'spring', duration: 1, bounce: 0 }}
					style={{
						position: 'relative',
						height: '100%'
					}}
				>
					<img
						src={circle}
						width={'85%'}
						style={{
							left: '3%',
							bottom: matchesMd ? '1.5%' : matchesSm ? '3%' : '1.5%',
							position: 'absolute'
						}}
						alt='Hand holding vote sign'
					/>

					<img
						src={vote}
						width={'82%'}
						style={{
							left: '0%',
							bottom: matchesMd ? '2.8%' : matchesSm ? '3%' : '3%',
							position: 'absolute'
						}}
						alt='Hand holding vote sign'
					/>
					<img
						src={donate}
						width={'60%'}
						style={{
							left: '21%',
							top: matchesMd ? '24%' : matchesSm ? '27%' : '24%',
							position: 'absolute'
						}}
						alt='hands holding donate sign'
					/>
				</motion.div>
			</Box>
		</Box>
	);
};

export default AnalysisHighlights;
